<div class="reviews">
  <div class="review-card">
    <!-- Header -->
    <div class="review-header">
      <div class="d-flex gap-2">
        <img
          class="avatar"
          [src]="reviews.profileInfo?.cdnUrl"
          alt="{{ reviews.reviewerName }}"
        />
        <div class="author">
          <span>By</span>
          <div>{{ reviews.reviewerName }}</div>
        </div>
      </div>

      <!-- <i class="fa-solid fa-quote-right quote"></i> -->
      <img
        src="/assets/images/comment-icon.svg"
        alt="comment"
        class="comment-icon"
      />
    </div>

    <!-- Body -->
    <p
      class="review-text"
      [innerHTML]="reviews.quote | ngGenericPipe : getReviewText"
    ></p>

    <!-- Rating + Platform -->
    <div class="review-footer">
      <div class="stars">
        <i
          *ngFor="let s of [].constructor(reviews.rating)"
          class="fa fa-star"
        ></i>
      </div>
      <img
        class="platform-logo"
        [src]="reviews.logoInfo?.cdnUrl"
        [alt]="'logo'"
      />
    </div>

    <!-- Date -->
    <div class="review-date">{{ reviews.date | date : "dd MMM yyyy" }}</div>
  </div>
</div>
